import { path } from 'ramda';
import { createSelector } from 'reselect';

export const getPendingReminderDelete = state => path(['reminder', 'pendingDelete'], state);
export const getEntities = state => path(['reminders', 'entities'], state);
export const getReminders = createSelector(getEntities, entities => Object.values(entities));



// WEBPACK FOOTER //
// ./src/redux/reminders/reminder.selector.js